import src from "IMAGE";
export default { src, width: 89, height: 89, blurWidth: 0, blurHeight: 0};
